import type { FaireProductEntity } from "../../entity_types/product";

export const p_dpsik4qn2q: FaireProductEntity = {
  token: "p_dpsik4qn2q",
  type: "product",
  name: '2" TOY FILLED EASTER EGG (24PCS/UNIT) LLB kids toys',
  brandToken: "b_7l6tbl88g3",
  brandName: "La Luna Bella - Toys",
  imageUrl:
    "https://cdn.faire.com/fastly/0f1554977fc7091a118c5da9f2b36cec30c090287497c218f329b90bc8548f63.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b855d2b9e2b4efd5a04a68536cddaf1a574af3416d3f5d694d1b86dd1b340abe.png",
    "https://cdn.faire.com/fastly/410d54702813f9be1a7bf73be3bcde5b9ac4990cf8adf86f118dd7536c1c0ec9.png",
    "https://cdn.faire.com/fastly/ae7629d5967bc365bfe5d1b8cc4dfb98643cf045b9a108db5454c78fc14b782a.png",
  ],
  priceDollars: 0.7,
  description:
    '• 2" Toy Filled Easter Egg \n• Sold in Poly Bag\n• Each egg features a prize in the interior\n• Various colors and prizes\n• 24 pieces per unit\n• 24 units per case\n• Ages 3+\n\nStock your store with the ultimate Easter goodies from La Luna Bella! Our 2 Toy-Filled Easter Eggs are the perfect Easter basket fillers and accessories to delight kids of all ages. Each vibrant egg comes packed with fun prizes inside, making them irresistible Easter toys. Sold in convenient poly bags, with 24 pieces per unit and 24 units per case, they’re ideal for retail shop owners looking to offer exciting Easter gifts this season. Order now and make every Easter unforgettable!',
  tags: [],
  msrpDollars: 1.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:38.176Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
